import { ApiQueryBuilder } from '@/hooks/use-api-query'
import { TenantBalance } from '@/types/agreement'
import { QueryKey } from '@/utils/query-key'

export const GetTenantBalance: ApiQueryBuilder<TenantBalance, { tenantId: string }, [string]> = ({ tenantId }) => ({
  queryKey: [QueryKey.TenantBalance, tenantId],
  queryFn: async (apiClient) => {
    const response = await apiClient.get<TenantBalance>('/agreements/tenant/balance')
    return response.data
  },
})
